import React, { useState } from "react";
import { Button, Input, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import { SalesScanStage, useSalesScanner } from "../sales/SalesScanPad";
import { parseIdentityToken } from "../../services/physicalIdentityApi";

export default function IdentityScanner() {
  const history = useHistory();
  const [code, setCode] = useState(""); const [error, setError] = useState("");
  const open = (raw: string) => {
    const token = parseIdentityToken(raw);
    if (!token) { setError("Enter the code printed beside the HKP QR, or scan the label again."); return; }
    history.push(`/q/${token}`);
  };
  const scan = useSalesScanner(open);
  return <section className="identity-scanner" aria-label="Scan an HKP label">
    <Label for="identity-code">Printed code or QR link</Label>
    <div className="identity-inline">
      <Input id="identity-code" value={code} onChange={e => setCode(e.target.value)} onKeyDown={e => { if (e.key === "Enter") open(code); }} autoComplete="off" />
      <Button className="btn-hastkala" onClick={() => open(code)}>Open label</Button>
      <Button outline onClick={scan.startCamera}>Scan QR</Button>
    </div>
    <input ref={scan.fileRef} type="file" accept="image/*" hidden onChange={e => { scan.onFile(e.target.files?.[0]); e.target.value = ""; }} />
    <SalesScanStage scan={scan} />{error && <p role="alert">{error}</p>}
  </section>;
}
